// src/redux/profiles/profileBootstrapSlice.ts

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getProfileMeApi } from "../../services/profiles/profileBootstrapApi";
import { ProfileMeType } from "../../types/profiles/profileMeTypes";

interface ProfileBootstrapState {
  data: ProfileMeType | null;
  loading: boolean;
  error: string | Record<string, any> | null;
}

const initialState: ProfileBootstrapState = {
  data: null,
  loading: false,
  error: null,
};

export const getProfileType = createAsyncThunk<
  ProfileMeType,
  void,
  { rejectValue: string | Record<string, any> }
>("profileBootstrap/getProfileType", async (_, { rejectWithValue }) => {
  try {
    return await getProfileMeApi();
  } catch (err: any) {
    return rejectWithValue(
      err.response?.data || "Failed to resolve active profile type."
    );
  }
});

const profileBootstrapSlice = createSlice({
  name: "profileBootstrap",
  initialState,
  reducers: {
    clearProfileBootstrap(state) {
      state.data = null;
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getProfileType.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getProfileType.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getProfileType.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export const { clearProfileBootstrap } = profileBootstrapSlice.actions;
export default profileBootstrapSlice.reducer;